import { css } from '@emotion/react';
import { SIDE_BAR_WIDTH } from '../../../../constants/sideBarWidth';

export const betaTileStyles = {
    container: css({
        width: '100%',
        height: 'fit-content',
        backgroundColor: '#FCE03E33',
        border: "1px solid #FCE03E",
        borderRadius: 5,
        backdropFilter: 'blur(24px)',
        padding: '8px 15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',

        '@media (min-width: 600px)': {
            padding: '13px 15px',
            maxWidth: `${SIDE_BAR_WIDTH}px`,
            gap: 12,
            justifyContent: 'flex-start'
        },
    }),
    title: css({
        fontSize: 10,
        fontWeight: 700,
        color: '#101010',

        '@media (min-width: 600px)': {
            fontSize: 13,
        },
    }),
    icon: css({
        width: 24,
        height: 24,
    })
}